module.exports = {"m_inscrire":"Sign up","je_ne_possede_pas_encore_de_compte":"I don't have an account yet"}


//////////////////
// WEBPACK FOOTER
// ./src/companies/casino/lang/en/home/welcome.lang.json
// module id = f8GC
// module chunks = 1